export default __webpack_public_path__ + "static/media/property_1_23.bd5899f8.webp";